function getAllCookies() {
  const allCookiesString = document.cookie; // Get the raw cookie string
  const cookieArray = allCookiesString.split(';'); // Split into individual cookie strings

  const cookies = {};
  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i].trim(); // Remove leading/trailing whitespace
    const parts = cookie.split('=');
    if (parts.length > 1) {
      const name = parts[0];
      const value = parts.slice(1).join('='); // Handle cases where cookie value contains '='
      cookies[name] = value;
    }
  }
  return cookies;
}

export const getCookie = (name) => {
  try {
    const decodedCookie = decodeURIComponent(document.cookie);
    const v = decodedCookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
  } catch (e) {
    return null;
  }
};

export const getCookieObject = (name) => {
  const value = getCookie(name);
  return value ? JSON.parse(value) : null;
};

export const putCookieObject = (name, obj, options = {}) => {
  const { path = '/', encoded = true } = options;
  const cookiePath = `;path=${path}`;
  const value = JSON.stringify(obj);
  document.cookie = `${name}=${
    encoded ? encodeURIComponent(value) : value
  }${cookiePath}`;
};
